import { CaseStatusPill } from "src/cases/common/CaseStatusPill";
import { useCaseTemplateWithVersions } from "src/cases/queries/templates";
import { CasePropertySchema } from "src/cases/queues/types";
import { getPropertyDisplay, getSubValueDisplayName } from "src/cases/utils";

export const CaseStatusPillWithSchema: React.FC<{
  templateId: string;
  versionId: string;
  status: string;
  subStatus?: string;
}> = ({ templateId, versionId, status, subStatus }) => {
  const { data: templateVersion } = useCaseTemplateWithVersions(templateId);
  const version = templateVersion?.versions?.find((v) => v.id === versionId);

  const statusSchema = version?.attributes?.case_properties?.status as
    | CasePropertySchema
    | undefined;
  const { variant, displayName: statusDisplayName } = getPropertyDisplay(
    status,
    statusSchema,
  );
  const subStatusDisplayName = getSubValueDisplayName(
    status,
    subStatus,
    statusSchema,
  );
  return (
    <CaseStatusPill
      status={statusDisplayName || status}
      subStatus={subStatusDisplayName || subStatus}
      variant={variant}
    />
  );
};
